/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Planboard grid bar component.
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .sym-entity-link{display:none}"];
export { styles as styles };
